export default {
  smart: {
    valor: "Valor",
    mantenimiento: "En mantenimiento",
    tiemporeal: {
      tiemporeal: "Tiempo real",
      qualitataire: "Calidad del aire",
      qualitataire_gasos: "Calidad de gases",
      qualitataire_particules: "Calidad de partículas",
      calidad3_1: "Bueno",
      calidad3_2: "Moderado",
      calidad3_3: "Malo",
      nivellso: "Nivel de sonido",
      gases: "Gases",
      qualitat_texto: "Para facilitar la comprensión del nivel de calidad de aire de Alcoy, se ha establecido una clasificación en 3 niveles a partir de la normativa del RD102/2011 y la Ley 39/2017.",
      qualitat: "Calidad",
      nivel: "Niveles",
      bueno: "Bueno",
      moderado: "Moderado",
      malo: "Malo",
      no2: "Dióxido de nitrógeno",
      no2_des: "El dióxido de nitrógeno u óxido de nitrógeno (IV) (NO2), es un compuesto químico formado por los elementos nitrógeno y oxígeno, uno de los principales contaminantes entre los varios óxidos de nitrógeno.",
      o3: "Ozono",
      o3_des: "El ozono es una sustancia cuya molécula está compuesta por tres átomos de oxígeno, formada al disociarse los dos átomos que componen el gas de oxígeno. Cada átomo de oxígeno liberado se une a otra molécula de oxígeno gaseoso (O2), formando moléculas de ozono (O3).",
      so2: "Dióxido de azufre",
      so2_des: "El dióxido de azufre, u óxido de azufre, es un óxido cuya fórmula molecular es SO₂. Es un gas incoloro con un característico olor asfixiante.",
      co: "Monóxido de carbono",
      co_des: "El monóxido de carbono, también denominado óxido de carbono (II), gas carbonoso y anhídrido carbonoso.",
      co2: "Dióxido de carbono",
      pm1_des: "Partículas de tamaño menor a 1 μm. Ejemplos: polvo ultra fino, partículas de combustión, bacterias y virus.",
      pm25_des: "Partículas de tamaño menor a 2,5 μm. Son partículas muy pequeñas suspendidas en el aire que tienen un diámetro de menos de 2,5 micras. La materia particulada incluye sustancias químicas orgánicas, polvo, hollín y metales, también pueden provenir de todas las clases de combustión, como la de los automóviles, camiones, fábricas, quemas de madera, quemas agrícolas y otras actividades.",
      pm10_des: "Partículas de tamaño menor a 10 μm. Ejemplos: polvo más grueso y partículas orgánicas, tamién podría ser ceniza, hollín, partículas metálicas, cemento o polen, dispersas en la atmósfera, y cuyo diámetro aerodinámico es menor que 10 µm.",
      actualizado: "Actualizado a ",
      particulas: "Partículas",
      nivelsonido: "Nivel de sonido",
      actual: "Actual",
      maximo: "Máximo",
      meteo: "Datos meteorológicos",
      temperatura: "Temperatura",
      humedad: "Humedad",
      presion: "Presión",
      luminosidad: "Luminosidad",
      radiacion_solar: "Radiación solar",
      viento_dir: "Dirección del viento",
      viento_vel: "Velocidad del viento",
      lluvia: "Cantidad de lluvia",
      aparcamiento: "Aparcamiento",
      plazas_totales: "Plazas totales",
      plazas_libres: "Plazas libres",
      energia: "Energía",
      energia_producida: "Energía producida",
      energia_consumida: "Energía consumida",
      energia_externa: "Energía externa",
    },
    indicadores: {
      indicadores: "Indicadores",
      ciudad: "Ciudad",
      economia: "Economía",
      agua: "Agua",
      entorno: "Entorno",
      salud: "Salud",
      residuos: "Residuos",
      tecnologia: "Tecnología",
      turismo: "Turismo",
      "ISO4.1_tit": "Población",
      "ISO4.1_des": "Población total de la ciudad (ISO4.1)",
      "ISO4.3_tit": "Densidad de población",
      "ISO4.3_des": "Densidad de población (ISO4.3)",
      "ISO4.18_tit": "Cambio anual de población",
      "ISO4.18_des": "Cambio anual de población (ISO4.18)",
      "ISO4.22_tit": "Población infantil",
      "ISO4.22_des": "Porcentaje de población que son niños entre 0-14 (ISO4.22)",
      "ISO4.16_tit": "Población joven",
      "ISO4.16_des": "Porcentaje de población que son personas jóvenes (ISO4.16)",
      "ISO4.23_tit": "Población adulta",
      "ISO4.23_des": "Porcentaje de población que son adultos entre 25-64 (ISO4.23)",
      "ISO4.17_tit": "Población mayor",
      "ISO4.17_des": "Porcentaje de población que son personas mayores de 65 (ISO4.17)",
      "ISO4.24_tit": "Ratio hombre/mujer",
      "ISO4.24_des": "Número de hombres por cada 100 mujeres (ISO4.24)",
      "ISO4.26_tit": "Población nacida en el extranjero",
      "ISO4.26_des": "Porcentaje de población que ha nacido en el extranjero (ISO4.26)",
      "ISO5.1_tit": "Tasa de desempleo",
      "ISO5.1_des": "Número de residentes en edad de trabajar que no tenían un empleo remunerado ni eran autónomos, pero sí podían trabajar y buscaban trabajo dividido por la población activa total (ISO5.1)",
      "ISO5.5_tit": "Desempleo juvenil",
      "ISO5.5_des": "Número total de jóvenes sin empleo dividido por la población activa joven (ISO5.5)",
      "ISO5.6_tit": "Número de empresas",
      "ISO5.6_des": "Número total de empresas en una ciudad dividido por una cienmilésima parte de la población total de la ciudad (ISO5.6)",
      "ISO8.2_tit": "Partículas en suspensión PM10",
      "ISO8.2_des": "Masa total de partículas recogidas en el rango de tamaño de PM10 dividida por el volumen de aire muestreado (ISO8.2)",
      "ISO8.2_pie": "Fuente: Conselleria de Medi Ambient, Aigua, Infraestructures i Territori",
      "ISO8.4_tit": "Concentración NO2",
      "ISO8.4_des": "Suma de las concentraciones diarias de todo el año dividida por 365 días (ISO8.4)",
      "ISO8.4_pie": "Fuente: Conselleria de Medi Ambient, Aigua, Infraestructures i Territori",
      "ISO8.5_tit": "Concentración SO2",
      "ISO8.5_des": "Suma de las concentraciones diarias de todo el año dividida por 365 días (ISO8.5)",
      "ISO8.5_pie": "Fuente: Conselleria de Medi Ambient, Aigua, Infraestructures i Territori",
      "ISO8.6_tit": "Concentración O3",
      "ISO8.6_des": "Suma de las concentraciones diarias de todo el año dividida por 365 días (ISO8.6)",
      "ISO8.6_pie": "Fuente: Conselleria de Medi Ambient, Aigua, Infraestructures i Territori",
      "ISO12.3_tit": "Médicos",
      "ISO12.3_des": "Número de médicos de medicina general o especialistas dividido por una cienmilésima parte de la población total de la ciudad (ISO12.3)",
      "ISO12.5_tit": "Enfermeras/Obstetricia",
      "ISO12.5_des": "Número total de enfermeras y personal de obstetricia dividido por una cienmilésima parte de la población total de la ciudad (ISO12.5)",
      "ISO12.6_tit": "Salud mental",
      "ISO12.6_des": "Número de profesionales de la salud mental dividido por una cienmilésima parte de la población total de la ciudad (ISO12.6)",
      "ISO21.1_tit": "Suministro agua potable",
      "ISO21.1_des": "Número total de personas con servicio de suministro de agua potable dividido por la población total de la ciudad (ISO21.1)",
      "ISO21.2_tit": "Acceso agua mejorada",
      "ISO21.2_des": "Población total con acceso a una fuente de agua mejorada dividida por la población total de la ciudad (ISO21.2)",
      "ISO21.3_tit": "Acceso instalaciones sanitarias",
      "ISO21.3_des": "Número total de personas que utilizan instalaciones de saneamiento mejoradas dividido por la población total de la ciudad (ISO21.3)",
      "ISO21.4_tit": "Consumo doméstico",
      "ISO21.4_des": "Consumo total de agua de la ciudad en litros por día para uso doméstico dividido por la población total de la ciudad (ISO21.4)",
      "ISO21.5_tit": "Consumo total",
      "ISO21.5_des": "Cantidad total de consumo de agua de la ciudad en litros por día dividida por la población total de la ciudad (ISO21.5)",
      "ISO21.6_tit": "Interrupciones servicio",
      "ISO21.6_des": "Cantidad total de horas de interrupción multiplicada por el número de hogares afectados dividido por el número de hogares (ISO21.6)",
      "ISO21.7_tit": "Pérdida de agua",
      "ISO21.7_des": "Volumen de agua abastecida menos el volumen de agua utilizada dividido por el volumen total de agua abastecida (ISO21.7)",
      IP_RE_RV1_tit: "Recogida Viaria - Resto",
      IP_RE_RV1_des: "Recogida Viaria - Resto",
      IP_RE_RV2_tit: "Recogida Viaria - Cartón",
      IP_RE_RV2_des: "Recogida Viaria - Cartón",
      IP_RE_RV3_tit: "Recogida Viaria - Cristal",
      IP_RE_RV3_des: "Recogida Viaria - Cristal",
      IP_RE_RV4_tit: "Recogida Viaria - Envases",
      IP_RE_RV4_des: "Recogida Viaria - Envases",
      IP_RE_RV5_tit: "Recogida Viaria - Voluminosos",
      IP_RE_RV5_des: "Recogida Viaria - Voluminosos",
      IP_RE_RV6_tit: "Recogida Viaria - Orgánica",
      IP_RE_RV6_des: "Recogida Viaria - Orgánica",
      IP_RE_RV7_tit: "Recogida Viaria - Limpieza viaria",
      IP_RE_RV7_des: "Recogida Viaria - Limpieza viaria",
      IP_RE_RV8_tit: "Recogida Viaria - Ropa textil",
      IP_RE_RV8_des: "Recogida Viaria - Ropa textil",
      IP_RE_RV9_tit: "Recogida Viaria - Aceite usado",
      IP_RE_RV9_des: "Recogida Viaria - Aceite usado",
      IP_RE_EC1_tit: "Ecoparque - Poda (más urbanizaciones)",
      IP_RE_EC1_des: "Ecoparque - Poda (más urbanizaciones)",
      IP_RE_EC2_tit: "Ecoparque - Madera",
      IP_RE_EC2_des: "Ecoparque - Madera",
      IP_RE_EC3_tit: "Ecoparque - Aparatos eléctricos y electrónicos",
      IP_RE_EC3_des: "Ecoparque - Aparatos eléctricos y electrónicos",
      IP_RE_EC4_tit: "Ecoparque - Tóxicos",
      IP_RE_EC4_des: "Ecoparque - Tóxicos",
      IP_RE_EC5_tit: "Ecoparque - Escombros",
      IP_RE_EC5_des: "Ecoparque - Escombros",
      IP_RE_EC6_tit: "Ecoparque - Plásticos",
      IP_RE_EC6_des: "Ecoparque - Plásticos",
      IP_RE_EC7_tit: "Ecoparque - Neumáticos",
      IP_RE_EC7_des: "Ecoparque - Neumáticos",
      IP_RE_EC8_tit: "Ecoparque - Colchones",
      IP_RE_EC8_des: "Ecoparque - Colchones",
      IP_RE_EC10_tit: "Ecoparque - Chatarra",
      IP_RE_EC10_des: "Ecoparque - Chatarra",
      IP_TE_SE1_tit: "Sede Electrónica - Visitas",
      IP_TE_SE1_des: "Número de páginas visitadas en la sede electrónica",
      IP_TE_WF1_tit: "Puntos Wi-Fi",
      IP_TE_WF1_des: "Número de puntos de acceso Wi-Fi",
      IP_TE_FO1_tit: "Fibra óptica",
      IP_TE_FO1_des: "Número de metros",
      IP_TU_VA1_tit: "Oficina de turismo - Visitas Personas",
      IP_TU_VA1_des: "Visitas atendidas en la oficina de turismo",
      IP_TU_PO1_tit: "Porcentaje de ocupación",
      IP_TU_PO1_des: "Porcentaje de ocupación alojamientos del destino",
      IP_TU_GT1_tit: "Gasto total",
      IP_TU_GT1_des: "Inversión Departamento de Turismo",
      IP_TU_NU1_tit: "Usuarios web Alcoi Turismo",
      IP_TU_NU1_des: "Número de usuarios individuales de la web Alcoy Turismo",
      IP_TU_NU2_tit: "Usuarios panel Multitouch 24h",
      IP_TU_NU2_des: "Número de usuarios individuales del panel Multitouch 24h",
      IP_TU_NV1_tit: "Visitas web Alcoy Turismo",
      IP_TU_NV1_des: "Número total de visitas de la web Alcoy Turismo",
      IP_TU_NV2_tit: "Visitas panel Multitouch 24h",
      IP_TU_NV2_des: "Número total de visitas del panel Multitouch 24h",
      IP_TU_TA1_tit: "Tourist Info Alcoi - Total personas atendidas en todos los medios",
      IP_TU_TA1_des: "Número total de personas atendidas por cualquier medio en la oficina de turismo",
      metros: "Metros",
      visitas: "Visitas",
      habitantes: "Habitantes",
      toneladas: "Toneladas",
      unidades: "Unidades",
      euros: "Euros",
      usuarios: "Usuarios",
      personas: "Personas",
    },
  },
};
